export const SUPPORTED_UPLOAD_EXTENSIONS = ['.pdf', '.docx', '.txt', '.rtf'];
export const UPLOAD_ACCEPT = SUPPORTED_UPLOAD_EXTENSIONS.join(',');
export const SUPPORTED_UPLOAD_FORMAT_LABEL = 'PDF, DOCX, TXT, or RTF';
export const LEGACY_DOC_GUIDANCE = 'Save legacy .doc files as .docx or PDF before uploading.';

export function isSupportedUploadFile(file) {
  const fileName = typeof file?.name === 'string' ? file.name.toLowerCase() : '';
  return SUPPORTED_UPLOAD_EXTENSIONS.some((extension) => fileName.endsWith(extension));
}

export function getUnsupportedUploadFormatMessage() {
  return `Please upload a ${SUPPORTED_UPLOAD_FORMAT_LABEL} file. ${LEGACY_DOC_GUIDANCE}`;
}
